export const AccessibleIcon = ({ style }: { style: React.CSSProperties }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      d="M13.3286 5.83333C13.6583 5.83333 13.9805 5.73559 14.2546 5.55245C14.5287 5.36931 14.7423 5.10902 14.8684 4.80447C14.9946 4.49993 15.0276 4.16482 14.9633 3.84152C14.899 3.51822 14.7402 3.22124 14.5071 2.98816C14.2741 2.75507 13.9771 2.59633 13.6538 2.53203C13.3305 2.46772 12.9954 2.50072 12.6908 2.62687C12.3863 2.75301 12.126 2.96664 11.9428 3.24072C11.7597 3.5148 11.662 3.83703 11.662 4.16667C11.662 4.60869 11.8376 5.03262 12.1501 5.34518C12.4627 5.65774 12.8866 5.83333 13.3286 5.83333ZM10.5786 15.3333C10.2446 15.7707 9.80752 16.1185 9.30636 16.3458C8.80519 16.5731 8.25555 16.6728 7.70648 16.636C7.15741 16.5992 6.62599 16.427 6.15967 16.1348C5.69334 15.8426 5.30661 15.4395 5.03398 14.9615C4.76136 14.4835 4.61132 13.9454 4.59727 13.3953C4.58322 12.8451 4.70558 12.3001 4.95345 11.8088C5.20131 11.3174 5.56696 10.8951 6.01776 10.5795C6.46856 10.2639 6.99049 10.0648 7.53696 10C7.75797 9.97569 7.96028 9.86458 8.09937 9.6911C8.23846 9.51763 8.30294 9.29601 8.27863 9.075C8.25432 8.85399 8.1432 8.65168 7.96973 8.51259C7.79626 8.3735 7.57464 8.30902 7.35363 8.33333C6.02754 8.40737 4.78519 9.00516 3.89986 9.9952C3.01453 10.9852 2.55875 12.2864 2.63279 13.6125C2.70683 14.9386 3.30463 16.1809 4.29466 17.0663C5.2847 17.9516 6.58588 18.4074 7.91196 18.3333C8.68819 18.3333 9.45375 18.1526 10.148 17.8055C10.8423 17.4583 11.4462 16.9543 11.912 16.3333C12.0446 16.1565 12.1015 15.9343 12.0703 15.7155C12.039 15.4967 11.9221 15.2993 11.7453 15.1667C11.5685 15.0341 11.3462 14.9771 11.1274 15.0084C10.9087 15.0396 10.7112 15.1565 10.5786 15.3333ZM16.2453 16.6667H15.412V12.5C15.412 12.279 15.3242 12.067 15.1679 11.9107C15.0116 11.7545 14.7996 11.6667 14.5786 11.6667H10.7703L12.1786 7.78333C12.1786 7.78333 12.1786 7.725 12.1786 7.69167V7.525C12.1827 7.47508 12.1827 7.42492 12.1786 7.375C12.1834 7.32233 12.1834 7.26934 12.1786 7.21667C12.1569 7.16778 12.1318 7.12045 12.1036 7.075C12.0786 7.02955 12.0478 6.98753 12.012 6.95C11.9762 6.90761 11.934 6.87106 11.887 6.84167C11.887 6.84167 11.887 6.79167 11.8203 6.775L8.08696 4.625H7.98696C7.93587 4.6034 7.88286 4.58666 7.82863 4.575H7.49529C7.4374 4.58697 7.38135 4.60659 7.32863 4.63333H7.23696L4.99529 5.94167C4.83598 6.03192 4.71082 6.17214 4.63917 6.34064C4.56751 6.50915 4.55336 6.69657 4.59888 6.87392C4.64441 7.05128 4.74708 7.20871 4.89103 7.32187C5.03498 7.43504 5.2122 7.49764 5.39529 7.5C5.54691 7.50399 5.69673 7.46654 5.82863 7.39167L7.68696 6.30833L10.387 7.875L8.81196 12.2167C8.80791 12.261 8.80791 12.3056 8.81196 12.35C8.80415 12.3997 8.80415 12.4503 8.81196 12.5C8.82732 12.6069 8.84959 12.7127 8.87863 12.8167L8.97029 12.9417C8.993 12.991 9.024 13.0361 9.06196 13.075C9.09758 13.1048 9.13677 13.1299 9.17863 13.15C9.22822 13.1881 9.28122 13.2216 9.33696 13.25C9.42779 13.283 9.52367 13.2999 9.62029 13.3H13.787V17.4667C13.787 17.6877 13.8748 17.8996 14.031 18.0559C14.1873 18.2122 14.3993 18.3 14.6203 18.3H16.287C16.508 18.3 16.7199 18.2122 16.8762 18.0559C17.0325 17.8996 17.1203 17.6877 17.1203 17.4667C17.1203 17.2457 17.0325 17.0337 16.8762 16.8774C16.7199 16.7211 16.508 16.6333 16.287 16.6333L16.2453 16.6667Z"
      fill="#667085"
    />
  </svg>
);

export const FootprintIcon = ({ style }: { style: React.CSSProperties }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <g clipPath="url(#clip0_3207_171122)">
      <path
        d="M3.33854 14.9993H7.92187V16.041C7.92187 16.6488 7.68043 17.2317 7.25066 17.6615C6.82089 18.0912 6.238 18.3327 5.63021 18.3327C5.02242 18.3327 4.43953 18.0912 4.00976 17.6615C3.57998 17.2317 3.33854 16.6488 3.33854 16.041V14.9993ZM6.72021 11.666L6.75771 11.556C7.39687 9.801 7.50521 9.47433 7.50521 9.166C7.50521 8.541 7.33604 7.79683 7.06521 7.27183C6.86354 6.88017 6.72187 6.766 6.67187 6.766C5.60521 6.766 4.58854 7.90267 4.58854 9.166C4.58854 9.96517 4.65104 10.6435 4.77771 11.4643L4.80937 11.666H6.72021ZM6.67187 5.09933C8.33854 5.09933 9.17187 7.49933 9.17187 9.166C9.17187 9.99933 8.75521 10.8327 8.33854 12.0827L7.92187 13.3327H3.33854C3.33854 12.4993 2.92188 11.2493 2.92188 9.166C2.92188 7.08267 4.58687 5.09933 6.67187 5.09933ZM16.7169 11.7477L16.536 12.7735C16.4305 13.3721 16.0915 13.9043 15.5936 14.253C15.0957 14.6016 14.4797 14.7382 13.881 14.6327C13.2824 14.5271 12.7503 14.1881 12.4016 13.6902C12.0529 13.1923 11.9163 12.5763 12.0219 11.9777L12.2035 10.9527L16.7169 11.7477ZM15.8419 8.20933C15.9794 7.79267 16.0927 7.4635 16.0944 7.45933C16.2627 6.911 16.3952 6.3735 16.4985 5.786C16.7177 4.54267 15.9135 3.24683 14.8635 3.061C14.8144 3.05267 14.6552 3.14017 14.3885 3.49017C14.0302 3.961 13.7352 4.66517 13.626 5.27933C13.5777 5.55433 13.5852 5.61683 13.851 7.16517C13.8885 7.3785 13.9194 7.57017 13.9477 7.76267L13.9644 7.87767L15.8419 8.20933ZM15.1535 1.42017C17.2069 1.78183 18.5019 4.0235 18.1402 6.07517C17.7785 8.12767 17.151 9.286 17.0069 10.1068L12.4927 9.311L12.2994 8.00767C12.106 6.70433 11.841 5.811 11.9852 4.991C12.2744 3.34933 13.5119 1.131 15.1535 1.42017Z"
        fill="#667085"
      />
    </g>
    <defs>
      <clipPath id="clip0_3207_171122">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const LightningBoltIcon = ({ style }: { style: React.CSSProperties }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.7164 9.397L9.04973 2.73033C9.12032 2.58917 9.26457 2.5 9.4224 2.5H14.198C14.5351 2.5 14.7326 2.87945 14.5393 3.15561L12.5405 6.01106C12.3471 6.28722 12.5447 6.66667 12.8818 6.66667H14.0923C14.4483 6.66667 14.6403 7.08422 14.4086 7.3545L6.63621 16.4223C6.32959 16.7801 5.75801 16.4339 5.93298 15.9964L8.103 10.5714C8.21247 10.2977 8.01092 10 7.71613 10H6.08908C5.77934 10 5.57788 9.674 5.7164 9.397Z"
      stroke="#2055FF"
      strokeWidth="1.5"
      strokeLinecap="round"
      fill="none"
    />
  </svg>
);

export const ChevronLeftIcon = ({ style }: { style: React.CSSProperties }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      d="M13.6603 17.1704L9.26969 12.5067C9.13546 12.3648 9.06836 12.1827 9.06836 12.0005C9.06836 11.8183 9.13549 11.636 9.26969 11.4942L13.6603 6.8306C13.9402 6.53529 14.4061 6.52286 14.7013 6.80184C14.9985 7.08181 15.009 7.54986 14.7301 7.84318L10.7905 12.0006L14.7301 16.158C15.0091 16.4513 14.9985 16.9173 14.7013 17.1993C14.4089 17.4772 13.9425 17.4649 13.6603 17.1704Z"
      fill="black"
    />
  </svg>
);

export const CrossIcon = ({ style }: { style: React.CSSProperties }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      d="M18 6L6 18M6 6L18 18"
      stroke="#101828"
      strokeWidth="1.45455"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CornerUpRitghtIcon = ({ style }: { style: React.CSSProperties }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      d="M12.5026 11.6673L16.6693 7.50065M16.6693 7.50065L12.5026 3.33398M16.6693 7.50065H6.66927C5.78522 7.50065 4.93737 7.85184 4.31225 8.47696C3.68713 9.10208 3.33594 9.94993 3.33594 10.834V16.6673"
      stroke="white"
      strokeWidth="1.92"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SmartphoneIcon = ({ style }: { style: React.CSSProperties }) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      d="M10.4974 14.9993H10.5057M6.33073 1.66602H14.6641C15.5845 1.66602 16.3307 2.41221 16.3307 3.33268V16.666C16.3307 17.5865 15.5845 18.3327 14.6641 18.3327H6.33073C5.41025 18.3327 4.66406 17.5865 4.66406 16.666V3.33268C4.66406 2.41221 5.41025 1.66602 6.33073 1.66602Z"
      stroke="#2055FF"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FlagIcon = ({ style }: { style: React.CSSProperties }) => (
  <svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
    <rect y="0.0234375" width="30" height="30" rx="6" fill="#EAF0FF" />
    <path
      d="M10 16.8984C10 16.8984 10.625 16.2734 12.5 16.2734C14.375 16.2734 15.625 17.5234 17.5 17.5234C19.375 17.5234 20 16.8984 20 16.8984V9.39844C20 9.39844 19.375 10.0234 17.5 10.0234C15.625 10.0234 14.375 8.77344 12.5 8.77344C10.625 8.77344 10 9.39844 10 9.39844V16.8984ZM10 16.8984V21.2734"
      stroke="#2055FF"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RedCircleIcon = ({ style }: { style: React.CSSProperties }) => (
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <circle cx="7" cy="7.5" r="5" stroke="#F04438" strokeWidth="4" />
  </svg>
);

export const DotsIcon = ({ style }: { style: React.CSSProperties }) => (
  <svg
    width="20"
    height="36"
    viewBox="0 0 20 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <circle cx="10" cy="2" r="1.5" fill="#70757A" />
    <circle cx="10" cy="10" r="1.5" fill="#70757A" />
    <circle cx="10" cy="18" r="1.5" fill="#70757A" />
    <circle cx="10" cy="26" r="1.5" fill="#70757A" />
    <circle cx="10" cy="34" r="1.5" fill="#70757A" />
  </svg>
);

export const LocationIcon = ({ style }: { style: React.CSSProperties }) => (
  <svg
    width="14"
    height="19"
    viewBox="0 0 14 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      d="M12 7.7C12 9.07161 11.4031 10.451 10.2115 12.0424C9.32895 13.2212 8.23171 14.3774 7 15.6392C5.76829 14.3774 4.67105 13.2212 3.78847 12.0424C2.59688 10.451 2 9.07161 2 7.7C2 4.77464 4.29132 2.5 7 2.5C9.70869 2.5 12 4.77463 12 7.7Z"
      stroke="#667085"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ElevatorIcon = ({ style }: { style: React.CSSProperties }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      d="M10 2.5V17.5M10 2.5H15.8333C16.2754 2.5 16.6993 2.67559 17.0118 2.98816C17.3244 3.30072 17.5 3.72464 17.5 4.16667V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H10V2.5ZM10 2.5H4.16667C3.72464 2.5 3.30072 2.67559 2.98816 2.98816C2.67559 3.30072 2.5 3.72464 2.5 4.16667V15.8333C2.5 16.2754 2.67559 16.6993 2.98816 17.0118C3.30072 17.3244 3.72464 17.5 4.16667 17.5H10V2.5Z"
      stroke="#2055FF"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const StairsIcon = ({ style, color }: { style: React.CSSProperties; color?: string }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      d="M12.9506 2.08203C12.3983 2.08203 11.9522 2.52975 11.9522 3.08203V7.08205H7.53553C6.98324 7.08205 6.53553 7.52977 6.53553 8.08205V12.4435C6.53553 12.4435 4.63298 12.4436 1.83662 12.4436C1.28435 12.4436 0.835938 12.8908 0.835938 13.4431C0.835936 14.7835 0.835942 16.8564 0.835942 17.4436L16.9985 17.4435C18.1235 17.4435 19.0355 16.573 19.0355 15.4991V2.08203C14.9834 2.08202 13.5706 2.08202 12.9506 2.08203Z"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PlayIcon = ({ style }: { style: React.CSSProperties }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      d="M4.16406 5.43066C4.16406 4.1648 5.56446 3.40025 6.62927 4.08478L13.7371 8.65411C14.7168 9.28393 14.7168 10.7161 13.7371 11.3459L6.62928 15.9152C5.56446 16.5997 4.16406 15.8352 4.16406 14.5693V5.43066Z"
      stroke="white"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PhoneIcon = ({ style }: { style: React.CSSProperties }) => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      d="M10.4974 15.4993H10.5057M6.33073 2.16602H14.6641C15.5845 2.16602 16.3307 2.91221 16.3307 3.83268V17.166C16.3307 18.0865 15.5845 18.8327 14.6641 18.8327H6.33073C5.41025 18.8327 4.66406 18.0865 4.66406 17.166V3.83268C4.66406 2.91221 5.41025 2.16602 6.33073 2.16602Z"
      stroke="#2055FF"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SearchIcon = ({ style }: { style: React.CSSProperties }) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      d="M19 19L15.1333 15.1333M17.2222 10.1111C17.2222 14.0385 14.0385 17.2222 10.1111 17.2222C6.18375 17.2222 3 14.0385 3 10.1111C3 6.18375 6.18375 3 10.1111 3C14.0385 3 17.2222 6.18375 17.2222 10.1111Z"
      stroke="#667085"
      strokeWidth="1.77778"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FilterIcon = ({ style, color }: { style: React.CSSProperties; color?: string }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      d="M18.3307 2.5H1.66406L8.33073 10.3833V15.8333L11.6641 17.5V10.3833L18.3307 2.5Z"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SortIcon = ({ style, color }: { style: React.CSSProperties; color?: string }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      d="M5 10H15M2.5 5H17.5M7.5 15H12.5"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DefaultTagIcon = ({ style }: { style: React.CSSProperties }) => (
  <svg
    width="38"
    height="39"
    viewBox="0 0 38 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <rect x="0.5" y="0.791016" width="38" height="38" rx="7.51147" fill="#EAF0FF" />
    <rect x="0.5" y="0.791016" width="38" height="38" rx="7.51147" stroke="#EAF0FF" />
    <g clipPath="url(#clip0_7805_13454)">
      <path
        d="M26.3125 19.291C26.3125 17.3516 25.5421 15.4917 24.1707 14.1203C22.7994 12.7489 20.9394 11.9785 19 11.9785C17.0606 11.9785 15.2006 12.7489 13.8293 14.1203C12.4579 15.4917 11.6875 17.3516 11.6875 19.291C11.6875 21.2304 12.4579 23.0904 13.8293 24.4617C15.2006 25.8331 17.0606 26.6035 19 26.6035C20.9394 26.6035 22.7994 25.8331 24.1707 24.4617C25.5421 23.0904 26.3125 21.2304 26.3125 19.291ZM10 19.291C10 16.9041 10.9482 14.6149 12.636 12.9271C14.3239 11.2392 16.6131 10.291 19 10.291C21.3869 10.291 23.6761 11.2392 25.364 12.9271C27.0518 14.6149 28 16.9041 28 19.291C28 21.678 27.0518 23.9671 25.364 25.655C23.6761 27.3428 21.3869 28.291 19 28.291C16.6131 28.291 14.3239 27.3428 12.636 25.655C10.9482 23.9671 10 21.678 10 19.291ZM19 15.916C19.8951 15.916 20.7536 16.2716 21.3865 16.9045C22.0194 17.5375 22.375 18.3959 22.375 19.291C22.375 20.1861 22.0194 21.0446 21.3865 21.6775C20.7536 22.3104 19.8951 22.666 19 22.666C18.1049 22.666 17.2464 22.3104 16.6135 21.6775C15.9806 21.0446 15.625 20.1861 15.625 19.291C15.625 18.3959 15.9806 17.5375 16.6135 16.9045C17.2464 16.2716 18.1049 15.916 19 15.916Z"
        fill="#2055FF"
      />
    </g>
    <defs>
      <clipPath id="clip0_7805_13454">
        <rect width="18" height="18" fill="white" transform="translate(10 10.291)" />
      </clipPath>
    </defs>
  </svg>
);

export const StationIcon = ({ style }: { style: React.CSSProperties }) => (
  <svg
    width="38"
    height="38"
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <rect x="0.5" y="0.5" width="38" height="38" rx="7.51147" fill="#EAF0FF" />
    <rect x="0.5" y="0.5" width="38" height="38" rx="7.51147" stroke="#EAF0FF" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.3097 27.0357C24.3097 27.5683 23.878 28 23.3454 28L14.6546 28C14.122 28 13.6903 27.5683 13.6903 27.0357C13.6903 26.5032 14.122 26.0714 14.6546 26.0714L15.9734 26.0714L15.9735 21.2005L12.3628 21.2005C11.0579 21.2005 10 20.2153 10 19L10 12.2005C10 10.9852 11.0579 10 12.3628 10L25.6372 10C26.9421 10 28 10.9852 28 12.2005L28 19C28 20.2153 26.9421 21.2005 25.6372 21.2005L22.0265 21.2005L22.0265 26.0714L23.3454 26.0714C23.878 26.0714 24.3097 26.5032 24.3097 27.0357ZM19.9558 26.0714L19.9558 21.2005L18.0442 21.2005L18.0442 26.0714L19.9558 26.0714ZM25.6372 19.272C25.7985 19.272 25.9292 19.1502 25.9292 19L25.9292 12.2005C25.9292 12.0503 25.7985 11.9286 25.6372 11.9286L12.3628 11.9286C12.2015 11.9286 12.0708 12.0503 12.0708 12.2005L12.0708 19C12.0708 19.1502 12.2015 19.272 12.3628 19.272L25.6372 19.272Z"
      fill="#2055FF"
    />
  </svg>
);

export const SendIcon = ({ style }: { style: React.CSSProperties }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill={style.fill ?? '#667085'}
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <g clipPath="url(#clip0_8203_23669)">
      <path
        d="M18.318 8.9668L2.56797 2.21645C2.42523 2.15527 2.27477 2.09375 2.1257 2.09375C1.82255 2.09375 1.52453 2.21676 1.30656 2.44707C0.982482 2.82184 0.907786 3.33125 1.11872 3.75348L4.375 10.0004L1.11883 16.2477C0.907892 16.6702 0.982598 17.1793 1.3067 17.5228C1.52425 17.7529 1.82209 17.8761 2.12514 17.8761C2.27455 17.8761 2.42506 17.8464 2.56776 17.7849L18.318 11.034C18.7321 10.8571 19.0003 10.45 19.0003 10C18.9683 9.55039 18.7328 9.14258 18.318 8.9668ZM3.35265 4.38875L14.4789 9.15664H5.8375L3.35265 4.38875ZM5.8375 10.8441H14.4754L3.35195 15.6113L5.8375 10.8441Z"
        fill={style.fill ?? '#667085'}
      />
    </g>
    <defs>
      <clipPath id="clip0_8203_23669">
        <rect width="18" height="18" fill="white" transform="translate(1 1)" />
      </clipPath>
    </defs>
  </svg>
);

export const FinishIcon = ({ style }: { style: React.CSSProperties }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <rect width="40" height="40" rx="10" fill="#F2F4F7" />
    <path
      d="M29 18C29 25 20 31 20 31C20 31 11 25 11 18C11 15.6131 11.9482 13.3239 13.636 11.636C15.3239 9.94821 17.6131 9 20 9C22.3869 9 24.6761 9.94821 26.364 11.636C28.0518 13.3239 29 15.6131 29 18Z"
      stroke="#2055FF"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 21C21.6569 21 23 19.6569 23 18C23 16.3431 21.6569 15 20 15C18.3431 15 17 16.3431 17 18C17 19.6569 18.3431 21 20 21Z"
      stroke="#2055FF"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DefaultCategoryIcon = ({ style }: { style: React.CSSProperties }) => (
  // <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
  //   <path d="M18 6L6 18M6 6L18 18" stroke="#101828" strokeWidth="1.45455" strokeLinecap="round" strokeLinejoin="round" />
  // </svg>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <g id="blood-test-svgrepo-com" clipPath="url(#clip0_7507_32941)">
      <path
        id="Vector"
        d="M10.1989 3.41406H4.33646C4.07732 3.41406 3.82879 3.517 3.64556 3.70024C3.46232 3.88348 3.35938 4.13201 3.35938 4.39114V10.2536C3.35938 10.5128 3.46232 10.7613 3.64556 10.9445C3.82879 11.1278 4.07732 11.2307 4.33646 11.2307H10.1989C10.4581 11.2307 10.7066 11.1278 10.8898 10.9445C11.0731 10.7613 11.176 10.5128 11.176 10.2536V4.39114C11.176 4.13201 11.0731 3.88348 10.8898 3.70024C10.7066 3.517 10.4581 3.41406 10.1989 3.41406ZM9.22187 9.27655H5.31354V5.36823H9.22187V9.27655ZM19.9698 3.41406H14.1073C13.8481 3.41406 13.5996 3.517 13.4164 3.70024C13.2331 3.88348 13.1302 4.13201 13.1302 4.39114V10.2536C13.1302 10.5128 13.2331 10.7613 13.4164 10.9445C13.5996 11.1278 13.8481 11.2307 14.1073 11.2307H19.9698C20.2289 11.2307 20.4774 11.1278 20.6607 10.9445C20.8439 10.7613 20.9468 10.5128 20.9468 10.2536V4.39114C20.9468 4.13201 20.8439 3.88348 20.6607 3.70024C20.4774 3.517 20.2289 3.41406 19.9698 3.41406ZM18.9927 9.27655H15.0844V5.36823H18.9927V9.27655ZM10.1989 13.1849H4.33646C4.07732 13.1849 3.82879 13.2878 3.64556 13.4711C3.46232 13.6543 3.35938 13.9028 3.35938 14.162V20.0245C3.35938 20.2836 3.46232 20.5321 3.64556 20.7154C3.82879 20.8986 4.07732 21.0015 4.33646 21.0015H10.1989C10.4581 21.0015 10.7066 20.8986 10.8898 20.7154C11.0731 20.5321 11.176 20.2836 11.176 20.0245V14.162C11.176 13.9028 11.0731 13.6543 10.8898 13.4711C10.7066 13.2878 10.4581 13.1849 10.1989 13.1849ZM9.22187 19.0474H5.31354V15.139H9.22187V19.0474ZM17.0385 13.1849C14.8831 13.1849 13.1302 14.9378 13.1302 17.0932C13.1302 19.2486 14.8831 21.0015 17.0385 21.0015C19.194 21.0015 20.9468 19.2486 20.9468 17.0932C20.9468 14.9378 19.194 13.1849 17.0385 13.1849ZM17.0385 19.0474C15.9608 19.0474 15.0844 18.1709 15.0844 17.0932C15.0844 16.0155 15.9608 15.139 17.0385 15.139C18.1162 15.139 18.9927 16.0155 18.9927 17.0932C18.9927 18.1709 18.1162 19.0474 17.0385 19.0474Z"
        fill={style.color || 'white'}
      />
    </g>
    <defs>
      <clipPath id="clip0_7507_32941">
        <rect
          width="23.45"
          height="23.45"
          fill={style.color || 'white'}
          transform="translate(0.0859375 0.484375)"
        />
      </clipPath>
    </defs>
  </svg>
);
